import { useSlidesLimit } from "@editor/hooks";
import { cn } from "@lib/cn";

const PLAN_STYLES = {
  container: {
    starter: "tw-bg-starter-background tw-border-starter-base/30",
    pro: "tw-bg-pro-background tw-border-pro-base/30",
    team: "tw-bg-team-background tw-border-team-base/30",
  },
  limit: {
    starter: "tw-bg-starter-base/30",
    pro: "tw-bg-pro-base/30",
    team: "tw-bg-team-base/30",
  },
  limitBar: {
    starter: "tw-bg-starter-base",
    pro: "tw-bg-pro-base",
    team: "tw-bg-team-base",
  },
  text: {
    starter: "tw-text-starter-base",
    pro: "tw-text-pro-base",
    team: "tw-text-team-base",
  },
};

const SlidesLimit = () => {
  const { slidesLength, slidesLimit, plan, isLocked } = useSlidesLimit();
  if (!isLocked || typeof slidesLimit !== "number") return null;

  return (
    <div className="tw-absolute tw-bottom-14 tw-left-3 tw-right-3 tw-z-20">
      <div
        className={cn(
          "tw-flex tw-min-h-14 tw-flex-col tw-justify-center tw-rounded-lg tw-border tw-border-solid tw-bg-starter-background tw-px-3 tw-py-2",
          PLAN_STYLES.container[plan as keyof typeof PLAN_STYLES.container],
        )}
      >
        <div className="tw-flex tw-items-center tw-justify-between">
          <span className="tw-font-sans tw-text-[11px]/normal tw-font-semibold tw-text-blue">
            Slides limit:
          </span>

          <span
            className={cn(
              "tw-font-sans tw-text-[10px]/normal tw-font-semibold tw-uppercase tw-tabular-nums",
              PLAN_STYLES.text[plan as keyof typeof PLAN_STYLES.text],
            )}
          >
            {slidesLength || 0}/{slidesLimit}
          </span>
        </div>

        <div
          className={cn(
            "tw-mt-2 tw-h-[6px] tw-w-full tw-overflow-hidden tw-rounded-lg",
            PLAN_STYLES.limit[plan as keyof typeof PLAN_STYLES.limit],
          )}
        >
          <span
            className={cn(
              "tw-block tw-h-full tw-rounded-lg",
              PLAN_STYLES.limitBar[plan as keyof typeof PLAN_STYLES.limitBar],
            )}
            style={{
              width: `${((slidesLength || 0) / slidesLimit) * 100}%`,
            }}
          ></span>
        </div>
        {/* <UpgradeButton variant={VARIANS[plan as keyof typeof VARIANS]} /> */}
      </div>
    </div>
  );
};

export default SlidesLimit;
